// extracted by mini-css-extract-plugin
export var closeButton = "_k2-1";
export var closeX = "_k2-3";
export var container = "_k2-0";
export var image = "_k2-2";